<template>
    <el-dialog :title="getTitleText()" :visible="isShow" :before-close="handleClose" width="30%">
        <el-form :model="form" ref="form">
            <el-form-item label="指定产品">
                <el-select v-if="services.length > 0" v-model="form.service" style="width:100%" placeholder="请选择所属产品">
                    <el-option
                            v-for="item in services"
                            :key="item.service_key"
                            :label="item.service_name"
                            :value="item.service_key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import AccountService from "~/services/CustomerAccounts";

    const SCENARIO_ACTIVE = 'active';
    const SCENARIO_DISABLE = 'disable';

    export default {
        name: "ActiveAccount",
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            accounts: {
                type: Array,
                default: [],
                required: true
            },
            display: {
                type: Boolean,
                default: false
            },
            scenario: {
                type: String,
                default: 'active'
            }
        },
        data() {
            return {
                isShow: true,
                services: [],
                form: {
                    customer_id: this.customerId,
                    service: '',
                    accounts: []
                }
            };
        },
        watch: {
            display: function (value, origin) {
                this.isShow = value;
            }
        },
        created() {
            this.isShow = this.display;
            if (this.services.length < 1) {
                this.getServices();
            }
        },
        methods: {

            getTitleText() {
                let text = '';
                if (this.scenario == SCENARIO_ACTIVE) {
                    text = '批量激活';
                } else if (this.scenario == SCENARIO_DISABLE) {
                    text = '批量禁用';
                }

                return text;
            },

            getServices() {
                AccountService.getServices().then(res => {
                    if (res.code == 0) {
                        this.services = res.data;
                    }
                }).catch(error => {
                    console.error(error);
                })
            },

            close(status = false) {
                this.isShow = false;
                this.$refs["form"].resetFields();
                this.$emit("callback", status);
            },

            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            submitForm() {
                this.form.accounts = this.accounts;
                if (this.scenario == SCENARIO_ACTIVE) {
                    AccountService.activeAccounts(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: "执行成功!",
                                type: "success",
                                showClose: true,
                            });
                            this.close(true);
                        }
                    }).catch(error => {
                        console.error(error);
                    })
                } else if (this.scenario == SCENARIO_DISABLE) {
                    AccountService.disable(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: "执行成功!",
                                type: "success",
                                showClose: true,
                            });
                            this.close(true);
                        }
                    }).catch(error => {
                        console.error(error);
                    })
                }

            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/dialog/ActiveAccount.vue